import { HStack, VStack, XButton, XScroll, XText } from "IZOX/_X";
import { ColorX, ZTime } from "IZOX/STATIC";
import _ from "lodash";
import { useCallback, useEffect, useState } from "react";
import OperBar from "../OperBar/OperBar";

function QClock({
  size,
  valDate,
  minTime,
  maxTime,
  minRange,
  directConfirm,
  onConfirm,
  onCancel,
  enableMinute = true,
  enableSecond,
  minStep = 1,
  secStep = 1
}){

  const [hour, setHour] = useState(0);
  const [minute, setMinute] = useState(0);
  const [second, setSecond] = useState(0);

  const _onConfirm = useCallback(() => {
    onConfirm?.(hour, minute, second);
  }, [onConfirm, hour, minute, second]);

  const _onCancel = useCallback(() => {
    onCancel?.();
  }, [onCancel]);

  useEffect(() => {
    if(valDate){
      const date = ZTime.Moment(valDate);
      setHour(date.hour());
      setMinute(date.minute());
      setSecond(date.second());
    }
  }, [valDate]);

  const _onBtnPress = useCallback((value, mode) => {
    if(mode === "hour"){
      setHour(value);
      if(directConfirm) 
        onConfirm?.(value, minute, second, mode);
    }else if(mode === "minute"){
      setMinute(value);
      if(directConfirm) 
        onConfirm?.(hour, value, second, mode);
    }else if(mode === "second"){
      setSecond(value);
      if(directConfirm) 
        onConfirm?.(hour, minute, value, mode);
    }
  }, [hour, minute, second, onConfirm, directConfirm]);

  const renderButton = useCallback((value, mode, isVal) => {
    return (
      <XButton onPress={() => _onBtnPress(value, mode)} key={value}
        p={3} bgColor={isVal ? ColorX.CSS("aliceblue") : ColorX.CSS("pureWhite")}>
        <HStack>
          <XText>
            {value.toString().padStart(2, "0")}
          </XText>
        </HStack>
      </XButton>
    );    
  }, [_onBtnPress]);

  const renderHourPicker = useCallback(() => {
    return (
      <XScroll fullWidth fullHeight masked pT={10}>
        {_.map(_.range(0, 24), (o) => renderButton(o, "hour", hour === o))}
      </XScroll>
    );
  }, [hour, renderButton]);

  const renderMinutePicker = useCallback(() => {
    return (
      <XScroll fullWidth fullHeight masked pT={10}> 
        {_.map(_.range(0, 60, minStep), (o) => renderButton(o, "minute", minute === o))}
      </XScroll>
    );
  }, [minStep, renderButton, minute]);

  const renderSecondPicker = useCallback(() => {
    return (
      <XScroll fullWidth fullHeight masked pT={10}>
        {_.map(_.range(0, 60, secStep), (o) => renderButton(o, "second", second === o))}
      </XScroll>
    );
  }, [secStep, renderButton, second]);

  return (
    <VStack width={size} height={size} bgColor={ColorX.CSS("pureWhite")} 
      round={5}>
      <VStack fullWidth fullHeight p={5}>
        <HStack flexShrink={0}>
          <XText bold fontFamily="Arial" fontSize={18}>
            {hour.toString().padStart(2, "0")}
          </XText>
          <XText bold fontFamily="Arial" fontSize={18}>
            {`:${minute.toString().padStart(2, "0")}`}
          </XText>
          {enableSecond &&
            <XText bold fontFamily="Arial" fontSize={18}>
              {`:${second.toString().padStart(2, "0")}`}
            </XText>}
        </HStack>
        <HStack flexGrow={1}>
          {renderHourPicker()}
          {enableMinute && renderMinutePicker()}
          {enableSecond && renderSecondPicker()}
        </HStack>
      </VStack>
      {!directConfirm && 
        <OperBar onConfirm={_onConfirm} onCancel={_onCancel}/>}
    </VStack>
  );

}

export default QClock;